import type { ICompany } from '@types'
import { ESubscriptionType } from '@types'

export const Feature = {
  KanbanView: 'kanbanView',
  CustomGatewaySettings: 'customGatewaySettings',
  OrderHistory: 'orderHistory',
  CustomStatuses: 'customStatuses',
  Notifications: 'notifications',
  Inventory: 'inventory',
  CustomerTags: 'customerTags',
} as const

export type FeatureKey = (typeof Feature)[keyof typeof Feature]

export function hasFeatureAccess(company: ICompany | undefined | null, feature: FeatureKey): boolean {
  if (!company?._tariff?._active) {
    return false
  }

  switch (feature) {
    case Feature.KanbanView:
    case Feature.CustomGatewaySettings:
    case Feature.OrderHistory:
    case Feature.CustomStatuses:
    case Feature.Notifications:
      return [ESubscriptionType.TARIFF_PRO, ESubscriptionType.TARIFF_TRIAL].includes(company._tariff.type)
    case Feature.CustomerTags:
    case Feature.Inventory:
      return true
    default:
      return false
  }
}
